import { RouterTable } from "@/types/api/login";
import { filterRouterHidden } from "@/handles/router";
// 侧边菜单

export type menuState = {
  menuRouter: RouterTable;
  menuId: number | null;
};

const state: menuState = {
  // 侧边菜单
  menuRouter: [],
  // 顶层id(栏目)
  menuId: 1,
};

const menu = {
  namespaced: true,

  state,
  getters: {
    getMenuRouter: (state: menuState) => {
      const list = filterRouterHidden(state.menuRouter);
      return list;
    },
  },
  mutations: {
    setMenu(state: menuState, router: RouterTable) {
      state.menuRouter = router;
    },

    setId(state: menuState, id: number) {
      state.menuId = id;
    },
  },
};

export default menu;
